import Vue from 'vue';

require('./bootstrap');
require('./main');
require('./filters');

import './helpers/string.helpers';
import './plugins/index';
import store from './store/store';

// window.Vue = require('vue');

// Vue.config.productionTip = false;

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const modulesFiles = require.context('../../app/Modules/', true, /\.vue$/i);
modulesFiles.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], modulesFiles(key).default));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

const app = new Vue({
    el: '#app',
    store
});
